export default {
    back: "Back",
    continue: "Continue",
    cancel: "Cancel",
    close: "Close",
    success: "Success",
    error: "Error",
    okay: "Okay",
    value: "Value",
    cancelled: "Cancelled",

    // icons
    computer: "Computer",
    inventory: "Inventory",
    searchBattle: "Search battle",

    dailyReward: "Join our discord for free to get daily rewards!",

    // user
    userIdNotShared: "Please grant access to your Twitch-ID.",

    // default screens
    notStarted: "Enter !pokestart to start your adventure!",
    notStartedDiscord: "Enter !pokestart to start your adventure!<br>If you need more help contact us on discord <br>https://discord.gg/cT3ThCj",
    notWhitelisted: "This channel is not whitelisted.",
        chooseChatBotLanguage: "Please choose the language of the chatbot:",
    notWhitelistedDiscord: "This channel is not whitelisted!<br>If you need more help contact us on discord <br>https://discord.gg/cT3ThCj",
    contactOnDiscord: "Join our discord to use our automated whitelist system where you can select the language of your choice:",

    loading: "Loading...",
    loadingFailed: "Loading failed. Please try again.",
    unknownError: "An unknown error occurred! Please try to refresh the webpage! <br> If the problem still persists report it to us on our discord <br>https://discord.gg/cT3ThCj",
    tokenExpired: "The Twitch authentication token expired. Please reload the website or restart your app",
    invalidToken: "<h5>Authentication failed</h5> Please be sure that your system clock is synced! <br> Otherwise the authentication will fail!<br><br>More solutions:<br>1) Page refresh<br>2) Disabling browser extensions<br>3) Revoke and grant the extension permission<br>4) Login and logout on twitch<br>5) Trying out a different browser<br><br>For more help join our discord <br> https://discord.gg/cT3ThCj",
    connectionFailed: "The connection to the server failed. Please try again later!"
};